import { FlexColumn } from '@gorila-shared-ui/components';
import { useRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { editJobTypeState } from '../../../storage/jobTypesStates';
import { JobTypeRequest } from '../../../types/jobs';
import { SkillListPicker } from '../skills/SkillListPicker';

export function JobTypeSkillFields() {
  const { css } = useStyles();
  const [form, setForm] = useRecoilState(editJobTypeState);

  const onChangeInput = (key: keyof JobTypeRequest, value: any) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <FlexColumn
      classNames={css({
        minHeight: '450px',
      })}
    >
      <SkillListPicker
        assignedSkills={form.technicianSkills}
        onAssignedChange={(skills) => onChangeInput('technicianSkills', skills)}
        required
      />
    </FlexColumn>
  );
}
